export default "__VITE_ASSET__DFgFMiY8__"